import * as React from "react";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { useLocalization } from "@shared-ui/localization-context";

interface PriceProps {
  isSoldOut?: boolean;
  priceToShow?: string;
  priceMessage?: string;
}

export const PriceContent = (props: PriceProps) => {
  const { formatText } = useLocalization();

  return (
    <div>
      {!props.isSoldOut ? (
        <UitkPriceLockup
          align={UitkPriceLockupAlign.LEFT}
          className="uitk-cell all-cell-shrink"
          lockupPrice={props.priceToShow}
          priceCaptionFirst={props.priceMessage}
        />
      ) : (
        <div className="uitk-type-heading-500 hotelSoldOut">
          <b>{formatText("recentlyViewedHotels.soldOut")}</b>
        </div>
      )}
    </div>
  );
};
